import { Component, Input, OnInit } from '@angular/core';
import { Session } from "../../../../models/program/session";
import { ProgramWithSessions } from "../../../../models/program/program-with-sessions";
import { SessionDetails } from "../../../../models/program/session-details";
import * as moment from 'moment-timezone'

@Component({
  selector: 'app-session-program-row',
  templateUrl: './session-program-row.component.html',
  styleUrls: ['./session-program-row.component.less']
})
export class SessionProgramRowComponent implements OnInit {
  @Input() program: ProgramWithSessions;

  constructor() { }

  ngOnInit() { }

  futureSessionCount(program: ProgramWithSessions): number {
    return program.sessions.filter((session) => session.future).length;
  }

  nextFutureSessionDescription(program: ProgramWithSessions): string {
    const sessions = program.sessions.filter((session) => session.future);
    if (sessions.length) {
      const startDate = moment(sessions[0].start_date).format("Do MMM YYYY");
      const endDate = moment(sessions[0].end_date).format("Do MMM YYYY");
      return `(Next session runs ${startDate} to ${endDate}.)`;
    }
  }


  nonFutureSessions(program: ProgramWithSessions): SessionDetails[] {
    return program.sessions.filter((session) => !session.future);
  }

  sessionClasses(session: SessionDetails): string[] {
    const classes = [];
    if(session.current && !session.launched) {
      classes.push('overdue');
    }
    else if (!session.future && !session.joinable && !session.current) {
      classes.push('awaiting-launch');
    }
    else {
      if (session.launched) {
        classes.push('active');
      }
      if (session.joinable) {
        classes.push('joinable');
      }
    }
    return classes;
  }

  sessionDescription(session: SessionDetails): string {
    const startDate = moment(session.start_date).format("Do MMM YYYY");
    const endDate = moment(session.end_date).format("Do MMM YYYY");
    const joiningCloses = moment(session.joining_closes).format("Do MMM YYYY");

    if(session.current && !session.launched) {
      return `(Scheduled to start ${startDate} but not launched.)`;
    }
    else if (!session.future && !session.joinable && !session.current) {
      let message = `(Scheduled to start ${startDate}.`;
      if (!session.launched) {
        message += ' Awaiting manual launch.';
      }
      message += ')';
      return message;
    }
    else {
      if (session.launched && session.joinable) {
        return `(Active until ${endDate}. Can join until ${joiningCloses}.)`
      }
      else if (session.launched) {
        return `(Active until ${endDate})`;
      }
      else if (session.joinable) {
        return `(Open for enrollment until ${joiningCloses}.`;
      }
    }
  }

  isJoinable(program: ProgramWithSessions): boolean {
    return program.sessions.filter(session => session.joinable).length > 0;
  }

  isRunning(program: ProgramWithSessions): boolean {
    return program.sessions.filter(session => session.launched).length > 0;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/sessions/session-program-row/session-program-row.component.ts